module.exports = __webpack_public_path__ + "img/logo__1.0b356676.png";